




































import {Vue, Component, Prop, Watch} from 'vue-property-decorator'
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import {mixins} from "vue-class-component";

@Component({})
export default class ObjektiCard2Tab8Beleske extends mixins(ComponentBaseMixin) {
    @Prop() notes!: [];
}
